<template>
  <div>
    <div
      v-if="showLoader"
      class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50"
    >
      <div
        class="animate-spin rounded-full h-12 w-12 border-t-4 border-b-4 border-yellow-500"
      ></div>
    </div>
    <div v-else class="relative overflow-x-auto shadow-md sm:rounded-sm mt-5">
      <table class="w-full text-left rtl:text-right text-gray-700">
        <thead>
          <tr class="bg-gray-100 leading-normal">
            <th scope="col" class="py-3 px-6">
              <div class="flex items-center">#</div>
            </th>
            <th scope="col" class="py-3 px-6">
              <div class="flex items-center">Visit Code</div>
            </th>
            <th scope="col" class="py-3 px-6">
              <div class="flex items-center">Patient Name</div>
            </th>
            <th scope="col" class="py-3 px-6">
              <div class="flex items-center">Patient Unique Code</div>
            </th>
            <th scope="col" class="py-3 px-6">
              <div class="flex items-center">Test Requested</div>
            </th>
            <th scope="col" class="py-3 px-6">
              <div class="flex items-center">Requesting Doctor</div>
            </th>
            <th scope="col" class="py-3 px-6">
              <div class="flex items-center">Visit Date/Time</div>
            </th>
            <th scope="col" class="py-3 px-6">
              <div class="flex items-center">Priority</div>
            </th>
            <!-- <th scope="col" class="py-3 px-6">
              <div class="flex items-center">Status</div>
            </th> -->
            <th scope="col" class="py-3 px-6">Action</th>
          </tr>
        </thead>
        <tbody class="text-gray-600 text-sm font-light">
          <tr
            v-for="(data, index) in paginatedData"
            :key="data.id"
            class="border-b border-gray-200 hover:bg-gray-100"
          >
            <td class="py-3 px-6 text-left whitespace-nowrap">
              {{ index + 1 }}
            </td>
            <td class="py-3 px-6 text-left">{{ data.VisitCode }}</td>
            <td class="py-3 px-6 text-left">{{ data.patient.FullName }}</td>
            <td class="py-3 px-6 text-left">{{ data.patient.unique_code }}</td>
            <td class="py-3 px-6 text-left">
              {{ formartTests(data.lab_tests) }}
            </td>
            <td class="py-3 px-6 text-left">
              {{ data.lab_tests[0].requested_by.Username }}
            </td>
            <td class="py-3 px-6 text-left">
              {{ data.VisitStartTime }}
            </td>
            <td class="py-3 px-6 text-left">
            <span
                :class="getPriorityClass(getHighestPriority(data.lab_tests))"
                class="px-2 py-1 rounded-full text-xs"
            >
                {{ getHighestPriority(data.lab_tests) }}
              </span>
            </td>
            <!-- <td class="py-3 px-6 text-left"> -->
            <!-- <span
                :class="getStatusClass(data.status.name)"
                class="px-2 py-1 rounded-full text-xs"
              >
                {{ data.status.name }}
              </span> -->
            <!-- </td> -->
            <td class="py-3 px-6 text-left">
              <button
                @click="viewLabRequest(data.VisitId)"
                class="bg-custom-yellow hover:bg-orange-600 text-white font-bold py-1 px-3 rounded"
              >
                View
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <PaginationComponent
      v-model:currentPage="currentPage"
      :totalPages="totalPages"
      @update:currentPage="goToPage"
    />

    <ConsultationPatientQueueModal
      :show="showConsultationModal"
      :visitId="selectedPatientId"
      @close="closeConsultationModal"
      @submit="handleAppointmentSubmit"
     state="create"/>
  </div>
</template>
<script>
//   import CustomButton from "@/components/CustomButton.vue";
import ConsultationPatientQueueModal from "@/views/modals/ConsultationPatientQueueModal.vue";
import PaginationComponent from "@/components/shared/pagination.vue";
import apiClient from "@/services/api";

export default {
  name: "ReceptionPatientQueueTab",
  components: {
    //   CustomButton,
    ConsultationPatientQueueModal,
    PaginationComponent,
  },
  mounted() {
    this.getPatientLabTests();
  },
  props: {
    searchQuery: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      showConsultationModal: false,
      selectedPatientId: null,
      showLoader: false,
      labRequests: [],
      currentPage: 1,
      itemsPerPage: 10,
    };
  },
  computed: {
    totalPages() {
      // Ensure `this.patients` and `this.itemsPerPage` are valid
      if (
        Array.isArray(this.labRequests) &&
        this.labRequests.length > 0 &&
        this.itemsPerPage > 0
      ) {
        return Math.ceil(this.labRequests.length / this.itemsPerPage);
      }
      return 0; // Return 0 if no data or invalid state
    },
    paginatedData() {
      const currentPage = Number(this.currentPage);
      const itemsPerPage = Number(this.itemsPerPage);
      const start = (currentPage - 1) * itemsPerPage;
      const end = start + itemsPerPage;
      return this.labRequests.slice(start, end);
    },
    getTriageColor() {
      return (triageCode) => {
        switch (triageCode) {
          case "Below 8":
            return "bg-red-500";
          case "9-13":
            return "bg-custom-yellow";
          case "14":
            return "bg-yellow-200";
          case "15":
            return "bg-green-500";
          case "Code Blue":
            return "bg-blue-500";
          default:
            return "";
        }
      };
    },
  },
  methods: {
    goToPage(pageNumber) {
      console.log("goToPage", pageNumber);
      this.currentPage = pageNumber;
    },
    sortedVisits(visits) {
      return visits.slice().sort((a, b) => {
        const priorityA = this.getHighestPriority(a.lab_tests);
        const priorityB = this.getHighestPriority(b.lab_tests);

        // Define priority order
        const priorityOrder = { STAT: 1, Urgent: 2, Normal: 3 };

        // return priorityOrder[priorityA] - priorityOrder[priorityB];
        const priorityDiff = priorityOrder[priorityA] - priorityOrder[priorityB];

        // If priorities differ, sort by priority
        if (priorityDiff !== 0) {
          return priorityDiff;
        }

        // If both are Normal (or same priority), sort by VisitStartTime
        return new Date(b.VisitStartTime) - new Date(a.VisitStartTime);
      });
    },
    getHighestPriority(labTests) {
      const priorities = labTests.map((test) => test.queue_priority);
      if (priorities.includes("STAT")) return "STAT";
      if (priorities.includes("Urgent")) return "Urgent";
      return "Normal";
    },
    async getPatientLabTests() {
      try {
        this.showLoader = true;
        const response = await apiClient.listPatientLabTests();
        if (response.success) {
          this.labRequests = this.sortedVisits(response.data);
          this.showLoader = false;
          // this.$toast.success("Facility services fetched successfully");
        } else {
          this.showLoader = false;
          this.$toast.error("Failed to fetch patient lab tests");
        }
      } catch (error) {
        this.showLoader = false;
        this.$toast.error("Failed to fetch patient lab tests");
      }
    },
    formartTests(tests) {
      const testNames = tests.map((test) => test.test_type.name).join(", ");
      return testNames;
    },
    getPriorityClass(priority) {
      switch (priority) {
        case "STAT":
          return "bg-red-100 text-red-800";
        case "Urgent":
          return "bg-yellow-100 text-yellow-800";
        default:
          return "bg-green-100 text-green-800";
      }
    },
    getStatusClass(status) {
      switch (status) {
        case "Pending":
          return "bg-blue-100 text-blue-800";
        case "Inprogress":
          return "bg-yellow-100 text-yellow-800";
        case "Completed":
          return "bg-green-100 text-green-800";
        case "Rejected":
          return "bg-red-100 text-red-800";
        default:
          return "bg-gray-100 text-gray-800";
      }
    },
    viewLabRequest(id) {
      this.$router.push({
        name: "LabRequestDetails",
        params: { lab_request_id: id },
      });
    },
  },
};
</script>

<style lang="css" scoped></style>
